import React from 'react';
import { ModelPreloader } from 'client/data/luckdragon/redux/model-preloader';
import { pageDefinition } from 'client/site-modules/shared/pages/page';
import { CmsModel, CmsPaths } from 'client/data/models/cms';
import { HomeModulesModel } from 'client/data/models/home-modules';

import { RESEARCH_LINK_WIDGET_EDITORIAL_PATH } from 'site-modules/shared/constants/editorial/research-article';
import { handle404Error } from 'site-modules/shared/utils/errors';
import { getResearchArticleContentPath } from 'site-modules/editorial/utils/content-path';
import { getSeoObject } from 'site-modules/editorial/pages/research-article/seo';
import { getCategoryName } from 'site-modules/editorial/utils/research-article';
import { removeSpecialCharacters } from 'site-modules/shared/utils/string';

import { ARTICLE_BREADCRUMBS, ARTICLE_CATEGORY, DEFAULT_CODE } from './constants';
import { ObdDtcCode } from './obd-dtc-code';

export default ({ codeId = DEFAULT_CODE }) =>
  pageDefinition({
    name: `maintenance_obd_dtc_${codeId === DEFAULT_CODE ? 'index' : 'code'}`,
    category: 'advice',
    adsCustomTargeting: {
      sect1: removeSpecialCharacters(codeId),
      sect2: 'obddtc',
    },
    component: () => <ObdDtcCode codeId={codeId} />,
    preload: store => {
      const preloader = new ModelPreloader(store);
      const articlePath = getResearchArticleContentPath(ARTICLE_CATEGORY, codeId);

      preloader.resolve(`content["${articlePath}"]`, CmsModel);

      return preloader.load().then(modelState => {
        const article = modelState.get(`content["${articlePath}"]`, CmsModel);
        if (!(article && article.id)) {
          throw handle404Error({ errorMessage: `No content was found for ${articlePath}` });
        }

        preloader.resolve(CmsPaths.buildAllAuthorsPath({ contentPath: articlePath }), CmsModel);
        preloader.resolve(`content["${RESEARCH_LINK_WIDGET_EDITORIAL_PATH}"]`, CmsModel);
        preloader.resolve('homeHeroContent', HomeModulesModel);

        return preloader.load();
      });
    },
    seo: state => {
      const articlePath = getResearchArticleContentPath(ARTICLE_CATEGORY, codeId);

      return {
        ...getSeoObject(state, articlePath, getCategoryName(ARTICLE_BREADCRUMBS), ARTICLE_CATEGORY),
      };
    },
  });
